import { RmaErrors } from '../../types/RmaErrors';

export const SET_RMA_TABLE_DATA = '@RMA_ERRORS/SET_RMA_TABLE_DATA';
export const RESET_STATE = '@RMA_ERRORS/RESET_STATE';
export const SET_IS_RMA_ERRORS_LOADING = 'RMA_ERRORS/SET_IS_RMA_ERRORS_LOADING';

export interface SetRmaTableData {
  type: typeof SET_RMA_TABLE_DATA;
  payload: {
    rmaErrors: RmaErrors[];
    total: number;
    nextPageUrl?: string;
  };
}

export interface SetIsErrorsLoading {
  type: typeof SET_IS_RMA_ERRORS_LOADING;
  payload: {
    isRmaErrorsLoading: boolean;
  };
}

export interface ResetState {
  type: typeof RESET_STATE;
}

export type RmaErrorManagementActionTypes = SetRmaTableData | SetIsErrorsLoading | ResetState;
